import React, { Component } from "react";
import { Layout } from "antd";
import { BrowserRouter as Router, Route } from "react-router-dom";
import createBrowserHistory from "history/createBrowserHistory";

//components

//containers
import { Client, Search, Results } from "./containers/pages";

//styles
import "./App.scss";

const { Content } = Layout;
const history = createBrowserHistory();

class App extends Component {
  state = {
    height: 0
  };

  render() {
    return (
      <Router history={history}>
        <Layout className="app-container">
          <Content>
            <Route exact path="/" component={Client} />
            <Route
              exact
              path="/search/new"
              component={props => <Search {...props} isNew={true} />}
            />
            <Route
              exact
              path="/search/existing"
              component={props => <Search {...props} isNew={false} />}
            />
            <Route exact path="/results" component={Results} />
          </Content>
        </Layout>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js